module.exports = __webpack_public_path__ + "img/6.b1b890f3.png";